// Enlarging a picture past this (after the screen's pixel density) blurs it: the full image is fetched instead of the thumbnail.
const SHARP_SCALE_LIMIT = 1.25

/** Whether a shown image is enlarged past sharpness: its pixels against its box (cropped to fill, as cards and tiles show pictures) at this screen's density. */
export function enlargedPastSharp(image: HTMLImageElement, density = typeof window === 'undefined' ? 1 : window.devicePixelRatio || 1): boolean {
  const { naturalWidth, naturalHeight, clientWidth, clientHeight } = image
  if (!naturalWidth || !naturalHeight || !clientWidth || !clientHeight) return false
  return Math.max(clientWidth / naturalWidth, clientHeight / naturalHeight) * density > SHARP_SCALE_LIMIT
}
